import { render } from "./InfoDoctorAndRoom.vue?vue&type=template&id=4bc640b2"
import script from "./InfoDoctorAndRoom.vue?vue&type=script&lang=js"
export * from "./InfoDoctorAndRoom.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__